export enum RoutesEnum {
  LOGIN = 'login',
  NOT_FOUND = 'not_found',

  LANDING = '/landing',
  SIGNUP =  'signup',
  WORK_SPACE = 'work_space',
  ADMIN_SETTINGS = '/admin_settings'
}


